import React, { useContext, useMemo } from "react";
import { useExport } from "../hooks/useExport";

export const ExportContext = React.createContext();

export const ExportProvider = ({ children }) => {
  const exportState = useExport()
  const value = useMemo(() => exportState, [exportState]);

  return <ExportContext.Provider value={value}>{children}</ExportContext.Provider>;
};
export function useExportContext() {
  return useContext(ExportContext);
}
